import { authorWorksResponseSchema } from '~/utils/solr/author-work'

export function useAuthorWorksQuery(authorId: MaybeRefOrGetter<number | undefined>, authorName: MaybeRefOrGetter<string | undefined>) {
  const endpoint = computed(() => `authors/${toValue(authorId)}/works`)

  const params = computed(() => ({
    authorName: toValue(authorName),
  }))

  const queryOptions = useSolrQueryOptions({
    endpoint,
    params,
    schema: authorWorksResponseSchema,
    enabled: () => !!toValue(authorId) && !!toValue(authorName),
    safe: true,
  })

  return useQuery(queryOptions)
}
